<template>
  <keep-alive :include="include">
    <router-view> </router-view>
  </keep-alive>

</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import reportStore from "./store";
export default {
  name: "report",
  data() {
    return {
      include: ["report-selection", "all-store-pnl-report", 'batch-selection'],
    };
  },
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("report", reportStore);
  }
};
</script>
